import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

const SYNTAX_CHARACTER_PATTERN = /([\^\$\.\*\+\?\(\)\[\{\}\|\\\]])/g;

@Pipe({ name: 'searchHighlight' })
export class SearchHighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(
    input: string | undefined | null,
    searchQuery: string | undefined | null,
  ): string {
    if (!input) {
      return '';
    }
    if (!searchQuery) {
      return input;
    }
    const marked = this.mark(input, searchQuery);
    const sanitizedHtml = this.sanitizer.sanitize(SecurityContext.HTML, marked);

    return sanitizedHtml ?? '';
  }

  private mark(input: string, searchQuery: string): string {
    // Use a regular expression from user's search query to find all
    // matches with case insensitivity (can't do with string param).
    // To build a valid regular expression, we escape syntax characters.
    // See more: https://tc39.es/ecma262/multipage/text-processing.html#prod-SyntaxCharacter
    const escapedSearchQuery = searchQuery.replace(
      SYNTAX_CHARACTER_PATTERN,
      '\\$1',
    );
    const search = new RegExp(`${escapedSearchQuery}`, 'gi');
    const marked = input.replace(search, (match) => `<mark>${match}</mark>`);

    return marked;
  }
}
